<template>
  <div
    v-if="$options.implementationChecklistResources[feature]"
    :class="$style.container"
    data-test-id="ChecklistResource_checklistContainer"
  >
    <a
      data-test-id="ChecklistResource_imageHref"
      :href="$options.implementationChecklistResources[feature].courseUrl"
      target="_blank"
      @click="handleImageClicked"
    >
      <img :src="$options.implementationChecklistResources[feature].image">
    </a>
    <div :class="$style.caption">
      <ParagraphBody
        weight="bold"
      >
        {{ $options.implementationChecklistResources[feature].courseTitle }}
        <Link
          data-test-id="ChecklistResource_linkHref"
          :href="$options.implementationChecklistResources[feature].courseUrl"
          isExternal
          target="_blank"
          :text="linkText"
          @click.native="handleLinkClicked"
        />
      </ParagraphBody>
    </div>
  </div>
</template>

<script>
import { Link, ParagraphBody } from '@jumpcloud/ui-components';
import {
  eventLocations, eventProperties, implementationChecklistResources,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const {
  description,
  location,
  section,
  text,
  toUrl,
} = eventProperties;

export default {
  name: 'ChecklistResource',

  components: {
    Link,
    ParagraphBody,
  },

  implementationChecklistResources,
  EventHelper,

  props: {
    feature: {
      required: true,
      type: String,
    },
  },

  computed: {
    linkText() {
      return this.$options.implementationChecklistResources[this.feature].hasVideo ? 'Watch Video' : 'Take Course';
    },
  },

  methods: {
    handleImageClicked() {
      this.$options.EventHelper.triggerLinkClicked({
        [description]: 'Checklist Resource Image clicked',
        [location]: eventLocations.discoverPage,
        [section]: `${this.feature} Card`,
        [toUrl]: this.$options.implementationChecklistResources[this.feature].courseUrl,
      });
    },

    handleLinkClicked() {
      this.$options.EventHelper.triggerLinkClicked({
        [description]: 'Checklist Resource Link clicked',
        [location]: eventLocations.discoverPage,
        [section]: `${this.feature} Card`,
        [text]: this.linkText,
        [toUrl]: this.$options.implementationChecklistResources[this.feature].courseUrl,
      });
    },
  },
};
</script>

<style scoped module>
.container {
  margin: auto;
}

.caption {
  background-color: var(--jcInformational50);
  padding: var(--jc-spacer);
}
</style>
